<template>
<v-app id="keep">

  <v-app-bar
    app
    clipped-left
    color="light-blue lighten-2"
  >

    <v-toolbar-title>
      <!-- <span class="title ml-3 mr-5">webØ</span> -->
      <span class="title ml-3 mr-5">MindSync</span>
    </v-toolbar-title>
   <!--  
    <v-autocomplete
      v-model="select"
      :loading="loading"
      :items="flinks"
      :search-input.sync="search"
      cache-items
      solo-inverted
      flat
      hide-details
      label="Search"
      prepend-inner-icon="search"
    /> -->

    <!-- <v-spacer /> -->

    <v-btn v-if='$store.getters.isLoggedIn' icon @click="$router.push('/recent')"><v-icon>history</v-icon></v-btn>
    <v-btn v-if='$store.getters.isLoggedIn' icon @click="$router.push('/')"><v-icon>dashboard</v-icon></v-btn>
    <v-btn v-if='$store.getters.isLoggedIn' icon @click="$router.push('/')"><v-icon>mdi-map</v-icon></v-btn>

    <v-spacer />

    <v-btn v-if='$store.getters.isLoggedIn' icon @click="$store.dispatch('ui/showPostDialog')"><v-icon>add</v-icon></v-btn>
    <v-btn v-if='$store.getters.isLoggedIn' icon @click="$store.dispatch('forceSync');"><v-icon>sync</v-icon></v-btn>

    <!-- <v-spacer /> -->

    <Menu v-if='$store.getters.isLoggedIn' />

  </v-app-bar>

  <!-- <NavigationDrawer /> -->

  <v-content>
    <router-view />
  </v-content>

  <NotificationBar />

  <DocumentEditor />

  <PreviewWindow />

  <CreatePost />

  <!-- <MainCtrl /> -->

  <v-footer
    color="primary lighten-1"
    padless
  >
    <v-row
      justify="center"
      no-gutters
    >
      <v-btn
        v-for="(link, i) in companylinks"
        :key="i"
        color="white"
        text
        rounded
        class="my-2"
        @click="openTab(link.url)"
      >
        {{ link.text }}
      </v-btn>
      <v-col
        class="primary lighten-2 py-4 text-center  white--text"
        cols="12"
      >
        <div mx-3>
          Made with <v-icon color="red">
            mdi-heart
          </v-icon> in Regina 🇨🇦
          <!-- (qp;jzm) -->
          <!-- (qwdazn) -->
          <!-- (peskzm) -->
          (pra;xc)
        </div>
        <div mx-3>
          Copyright &copy; {{ new Date().getFullYear() }} — <strong>ØStudio Inc.</strong> All rights reserved.
        </div>
      <!-- Made with ❤️ in Regina, Canada -->
      </v-col>
    </v-row>
  </v-footer>

</v-app>
</template>


<script>

// import CardsLine from './components/CardsLine';
import DocumentEditor from './components/DocumentEditor'
import PreviewWindow from './components/PreviewWindow'
import CreatePost from './components/CreatePost'
import NotificationBar from './components/NotificationBar'
// import MainCtrl from './components/MainCtrl'

import Menu from './components/Menu'

// import NavigationDrawer from './components/NavigationDrawer'

// var clinks = require('./clinks.json');
// import msapi from './api/mindsync'


export default {
  components: {
    // CardsLine,
    DocumentEditor,
    PreviewWindow,
    CreatePost,
    NotificationBar,
    // MainCtrl,
    Menu,
    // NavigationDrawer,
  },
  data: () => ({
    loading: false,
    flinks: [],
    search: null,
    select: null,      

    companylinks: [
      {text: 'about', url: 'https://www.0studio.io/mindsync'},
      {text: 'blog', url: 'https://www.0studio.io/'},
      {text: 'contact us', url: 'https://www.0studio.io/'},
    ]
  }),

  watch: {
    search (val) {
      val && val !== this.select && this.querySelections(val)
    },
  },
  methods: {
    onLogin () {
      console.log('> onLogin')
    },

    onKeydown (event) {
      // console.log(event);
      if (event.key === 'q') {
        this.$store.dispatch('ui/closePreviewWin');
      } else if (event.key === 'r') {
        this.$store.dispatch('forceSync');
      }
    },

    querySelections (v) {
      this.loading = true
      // Simulated ajax query
      setTimeout(() => {
        this.flinks = this.$store.state.included.filter(e => {
          // console.log(e.attributes.note)
          return (e.attributes.note || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
        }).map(e => {return e.attributes.note})
        console.log(`v: ${v} | flinks: ${this.flinks.length}`)
        console.log(`select: ${this.select}`)
        this.loading = false
      }, 500)
    },

    openTab (path) {
      window.open(path, '_blank');
    },

  },
  created () {
    window.addEventListener('keydown', this.onKeydown);
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.onKeydown)
  },
  mounted () {
    this.$store.dispatch("doRefresh");
    // this.$store.dispatch("sync");
  },
}
</script>


<style scoped>
body {
  font-size: 14px;
}

.app-nav-item {
  height: 2em;
}
</style>
